<template>
  <div>
    <v-card :height="cardHeight" elevation="0" class="main-card-detail">
      <v-row no-gutters class="items">
        <v-icon color="darkColor" class="mr-3">{{ icon }}</v-icon>
        <span :class="titleClass">{{ title }}</span>
        <v-spacer></v-spacer>
        <div :class="triangle"></div>
        <v-row :class="whiteSpace" no-gutters>
          <v-col :class="textSpace" dir="ltr">
            <v-btn
              v-if="isPhoneNumber(text)"
              small
              text
              class="normal-letter-spacing mt-n1"
              :class="textClass"
              @click="callToCode(text)"
            >
              {{ text }}
            </v-btn>
            <span v-else :class="textClass" @click="setTimeBy800(per, perKey)">{{ text }}</span>
            <v-icon v-if="hasIcon" x-small color="darkColor">mdi-account mdi-8px</v-icon>
            <v-icon v-if="secondText" color="darkColor">mdi-minus mdi-rotate-90</v-icon>
            <span v-if="secondText" class="items-text-time2">
              {{ secondText }}
            </span>
            <v-icon v-if="secondText && hasIcon" x-small color="darkColor">
              mdi-vector-square mdi-8px
            </v-icon>
          </v-col>
        </v-row>
      </v-row>
    </v-card>
  </div>
</template>
<script>
  import CallMixin from '../Mixins/Call/CallMixin';
  export default {
    mixins: [CallMixin],
    mounted() {
      if (this.size == 4) {
        this.whiteSpace = 'white-space-4';
        this.titleClass = 'text-center items-title mr-2';
        this.textClass = 'items-text';
        this.cardHeight = '8vh';
        this.triangle = 'triangle-topleft';
        this.textSpace = 'text-center items-text-space';
      } else if (this.size == 8) {
        this.whiteSpace = 'white-space-8';
        this.titleClass = 'text-center items-title mr-2';
        this.textClass = 'items-text';
        this.cardHeight = '8vh';
        this.triangle = 'triangle-topleft';
        this.textSpace = 'text-center items-text-space';
      } else if (this.size == 12) {
        this.whiteSpace = 'white-space-12';
        this.titleClass = 'text-center items-title mr-2';
        this.textClass = 'items-text';
        this.cardHeight = '8vh';
        this.triangle = 'triangle-topleft';
        this.textSpace = 'text-center items-text-space';
      } else if (this.size == 3) {
        this.whiteSpace = 'white-space-3';
        this.titleClass = 'text-center items-title-time mr-2';
        this.textClass = 'items-text-time';
        this.cardHeight = '7vh';
        this.triangle = 'triangle-topleft-time';
        this.textSpace = 'text-center items-text-space-time';
      }
    },
    props: {
      title: {
        type: String,
        require: true,
      },
      text: {
        type: String,
        require: true,
      },
      icon: {
        type: String,
        require: true,
      },
      size: {
        type: Number,
        require: true,
        default: 4,
      },
      per: {
        type: Boolean,
        require: false,
        default: false,
      },
      secondText: {
        type: String,
        require: false,
        default: '',
      },
      perKey: {
        type: String,
        require: false,
        default: '',
      },
      hasIcon: {
        type: Boolean,
        require: false,
        default: false,
      },
    },
    data() {
      return {
        whiteSpace: 'white-space-4',
        titleClass: 'text-center items-title mr-2',
        textClass: 'items-text',
        cardHeight: '8vh',
        triangle: 'triangle-topleft',
        textSpace: 'text-center items-text-space',
      };
    },
    methods: {
      setTimeBy800: function (per, perKey) {
        if (per == true) {
          this.$root.$refs.Edit800Mission.showSetTimeModal(perKey);
        }
      },
      isPhoneNumber: function (number) {
        const iranPhoneRegex = /^(\+98|0)?9\d{9}$/;
        return iranPhoneRegex.test(number);
      },
      phoneText: function (phoneNumber) {
        const withCountryCode = phoneNumber?.replace('0', '+98');
        return withCountryCode;
      },
      callToCode: function (to) {
        const body = { to };
        this.callToCodeFunction(body);
      },
    },
  };
</script>
<style scoped>
  .main-card-detail {
    border-right: 1px solid var(--dark-color) !important;
    border-left: 1px solid var(--dark-color) !important;
    border-radius: 13px !important;
    background: var(--background-color) !important;
  }
  .white-space-12 {
    background: white;
    height: 7.4vh !important;
    width: 80% !important;
    margin-top: 0.3vh !important;
    margin-left: 1px !important;
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
  }
  .white-space-8 {
    background: white;
    height: 7.4vh !important;
    width: 70% !important;
    margin-top: 0.3vh !important;
    margin-left: 1px !important;
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
  }
  .white-space-4 {
    background: white;
    height: 7.4vh !important;
    width: 50% !important;
    margin-top: 0.3vh !important;
    margin-left: 1px !important;
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
  }
  .white-space-3 {
    background: white;
    height: 6.4vh !important;
    width: 35% !important;
    margin-top: 0.3vh !important;
    margin-left: 1px !important;
    border-top-left-radius: 8px !important;
    border-bottom-left-radius: 8px !important;
  }
  .triangle-topleft {
    margin-top: 0.3vh !important;
    width: 0;
    height: 0;
    border-top: 7.4vh solid white;
    border-right: 7.4vh solid transparent;
  }
  .triangle-topleft-time {
    margin-top: 0.3vh !important;
    width: 0;
    height: 0;
    border-top: 6.4vh solid white;
    border-right: 6.4vh solid transparent;
  }
  .items {
    margin-top: 3vh !important;
  }
  .items-title {
    margin-top: 2.5vh !important;
    color: #212121;
    font-size: 14px !important;
    font-weight: 500;
  }
  .items-title-time {
    margin-top: 2vh !important;
    color: #212121;
    font-size: 12px !important;
    font-weight: 500;
  }
  .items-text-space {
    margin-top: 2.1vh !important;
  }
  .items-text-space-time {
    margin-top: 1.7vh !important;
  }
  .items-text {
    color: #272727;
    font-size: 13px !important;
    font-weight: 500;
  }
  .items-text-time {
    color: #272727;
    font-size: 11px !important;
    font-weight: 500;
    cursor: pointer;
  }
  .items-text-time2 {
    color: var(--dark-color);
    font-size: 11px !important;
    font-weight: 500;
  }
</style>
